import * as ACTIONS from "./types"
import { mutateDataset } from "services/mutator/mutator.service"

// Action to mutate the data
// This is hard set to require plans, devices, extras and benefits
export const mutateData = (rules, globals) => (dispatch, getState) => {
  // ok, let's get the data from state
  const { plans, devices, benefits, extras } = getState()

  const data = {
    plans: plans.byID,
    devices: devices.byID,
    benefits: benefits.byID,
    extras: extras.byID,
    planBuilder: plans.buildAPlanByStores
  }

  // Run the data and rules through the mutator-tron-3000
  const mutatedData = mutateDataset(data, rules, globals)

  // Now replace the data in redux
  mutatedData.plans &&
    dispatch(
      replacePlans({
        plans: mutatedData.plans,
        planBuilder: mutatedData.planBuilder
      })
    )
  mutatedData.devices && dispatch(replaceDevices(mutatedData.devices))
  mutatedData.benefits && dispatch(replaceBenefits(mutatedData.benefits))
  mutatedData.extras && dispatch(replaceExtras(mutatedData.extras))
}

// Actions for replacing each part of data
const replacePlans = payload => ({
  type: ACTIONS.REPLACE_PLANS,
  payload
})

const replaceDevices = payload => ({
  type: ACTIONS.REPLACE_DEVICES,
  payload
})

const replaceBenefits = payload => ({
  type: ACTIONS.REPLACE_BENEFITS,
  payload
})

const replaceExtras = payload => ({
  type: ACTIONS.REPLACE_EXTRAS,
  payload
})
